import { COLORS } from 'helpers/globals'

export default {
  container: {
    paddingTop: 25,
    position: 'relative',
    height: '100%',
    width: '100%',
    borderTop: `1px solid ${COLORS.quaternary}`
  },
  valueDisplay: {
    color: 'black',
    fontSize: '1.8rem',
    fontWeight: 400,
    textAlign: 'center'
  },
  controls: {
    width: '100%',
    textAlign: 'center'
  },
  increaseDistance: {
    cursor: 'pointer',
    margin: '0 .5rem',
    fontSize: '2rem',
    color: COLORS.primary
  },
  decreaseDistance: {
    cursor: 'pointer',
    marginRight: '.5rem',
    fontSize: '2rem',
    color: COLORS.primary
  },
  distanceAway: {
    textAlign: 'center',
    fontSize: '1.3rem',
    lineHeight: '1.3rem'
  },
  warning: {
    fontSize: '.9rem',
    textAlign: 'center',
    position: 'absolute',
    bottom: 0,
    color: 'black',
    backgroundColor: COLORS.initial,
    borderBottom: `1px solid ${COLORS.quaternary}`,
    lineHeight: '1.1rem',
    padding: '.3rem 0'
  },
  reallyBold: {
    fontWeight: 500,
    color: 'black'
  }
}



// WEBPACK FOOTER //
// ./src/components/PpfPreview/PpfPreviewControls/style.js